import * as React from 'react';
import renderHTML from 'react-render-html';
import { thousandNumberFormat } from '../../Common/Helpers';
import { HomeStateInfo } from "./../../../interface/FactSheetInterface"

interface Props {
    stayed_bullet: string;
}


const DoctorBullets = ({ stayed_bullet }: Props) => {
    if (stayed_bullet !== undefined)
        return (
            <div className="row" style={{ marginTop: "20px", marginBottom: "20px" }}>
                <div className="col-md-12">
                    {renderHTML(stayed_bullet)}
                </div>
            </div>
        );
    return (<div></div>)
}

export default DoctorBullets;